import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useClickAway } from 'ahooks';
import { useIntl } from 'umi';
import { Button, PopConfirm, TextArea } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

interface IMessageItem<S = string> {
  id: number;
  text: S;
  textEn: S;
}

interface IFeedbackPopConfirmProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (data: {
    feedback: string[];
    feedbackContent: string;
    list: string[];
  }) => void;
  messageList: IMessageItem[];
  title: string;
}

// Ai点踩反馈弹框
export const IWikiFeedbackPopConfirm = memo(
  ({
    visible,
    onClose,
    onConfirm,
    messageList,
    title,
  }: IFeedbackPopConfirmProps) => {
    const { formatMessage } = useIntl();
    const [active, setActive] = useState<string[]>([]);
    const [text, setText] = useState('');
    const timer: any = useRef(null);
    const isEn = false;

    useClickAway(
      () => {
        timer.current = setTimeout(() => {
          visible && onClose();
        }, 100);
      },
      () => document.querySelector('.dba-feedback-pop-confirm-iwiki'),
    );

    // 重置
    useEffect(() => {
      setActive([]);
      setText('');
      return () => {
        clearTimeout(timer.current);
      };
    }, [visible]);

    // 点击勾选
    const handleActive = (value: string) => {
      setActive((res) => {
        if (res.includes(value)) {
          return res.filter((item) => item !== value);
        }
        return [...res, value];
      });
    };

    // 点击确认
    const handleConfirm = (value: string) => {
      // onClose();
      setText(value);
      onConfirm({ feedback: active, feedbackContent: text, list: messageList });
    };

    return (
      <PopConfirm
        visible={visible}
        className="dba-feedback-pop-confirm-iwiki"
        title={
          <div className="dba-feedback-pop-confirm-title">
            <span>{title}</span>
            <span>
              <SvgIcon type="clonse" onClick={onClose} style={{width: '14px', height: '14px'}}/>
            </span>
          </div>
        }
        message={
          <>
            <div className="dba-feedback-pop-confirm-list">
              {messageList?.map((item) => (
                <div
                  className={classNames('dba-feedback-pop-confirm-list-item', {
                    'dba-feedback-pop-confirm-list-item-active':
                      active.includes(item.id),
                  })}
                  onClick={() => handleActive(item.id)}
                  key={item.id}
                >
                  {isEn ? item.textEn : item.text}
                </div>
              ))}
              <TextArea
                size={'full'}
                value={text}
                onChange={(value) => setText(value)}
                placeholder={formatMessage({
                  id: 'dba_chat_feedback_placeholder',
                })}
              />
            </div>
          </>
        }
        escapeWithReference
        arrowPointAtCenter
        placement="bottom-end"
        footer={(close) => (
          <div>
            <Button
              // className="dba-feedback-pop-confirm-footer-cancel"
              onClick={() => {
                close();
                onClose();
              }}
            >
              取消
            </Button>
            <Button
              disabled={!active.length && !text}
              type="primary"
              // className="dba-feedback-pop-confirm-footer-confirm"
              onClick={handleConfirm}
            >
              提交
            </Button>
          </div>
        )}
      />
    );
  },
);
